import './mui-tiptap-theme.d';
import type { Components, Theme } from '@mui/material';
import { designTokens } from '../themes/design-tokens';

/**
 * Theme configuration for mui-tiptap components
 * Following mui-tiptap's component naming and slot structure
 */
export const muiTipTapTheme: Components<Theme> = {
  'MuiTiptap-FieldContainer': {
    defaultProps: {
      variant: 'standard',
    },
    styleOverrides: {
      root: ({ theme }) => ({
        width: '100%',
        height: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.customShape.borderRadiusSmall,
      }),
    },
  },

  'MuiTiptap-MenuButton': {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(1),
        color: theme.palette.text.primary,
        transition: theme.transitions.create(['background-color']),

        '& svg': {
          fontSize: 18,
        },
      }),
    },
  },

  'MuiTiptap-RichTextEditor': {
    styleOverrides: {
      root: ({ theme }) => ({
        width: '100%',
        height: '100%',
        fontFamily:
          theme.typography.fontFamily ??
          designTokens.typography.fontFamily.primary,
      }),
      content: ({ theme }) => ({
        width: '100%',
        height: '100%',
        padding: `${theme.spacing(1.25)} ${theme.spacing(3)}`,
        border: `1px solid ${theme.palette.text.fourth}`,
        borderRadius: theme.customShape.borderRadiusSmall,
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        overflowX: 'hidden',
      }),
    },
  },

  'MuiTiptap-RichTextContent': {
    styleOverrides: {
      root: ({ theme }) => ({
        width: '100%',
        height: '100%',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        '& img': {
          borderRadius: theme.customShape.borderRadiusSmall,
        },
      }),
      editable: () => ({
        width: '100%',
        height: '100%',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        '& .tiptap.ProseMirror': {
          height: '100%',
          outline: 'none',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
        },
      }),
    },
  },

  'MuiTiptap-MenuDivider': {
    styleOverrides: {
      root: ({ theme }) => ({
        width: theme.spacing(0),
        height: theme.typography.pxToRem(13.5),
      }),
    },
  },

  'MuiTiptap-MenuSelectHeading': {
    styleOverrides: {
      paragraphOption: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
      }),
      headingOption1: ({ theme }) => ({
        fontSize: theme.typography.h1.fontSize,
      }),
      headingOption2: ({ theme }) => ({
        fontSize: theme.typography.h2.fontSize,
      }),
      headingOption3: ({ theme }) => ({
        fontSize: theme.typography.h3.fontSize,
      }),
      headingOption4: ({ theme }) => ({
        fontSize: theme.typography.h4.fontSize,
      }),
      headingOption5: ({ theme }) => ({
        fontSize: theme.typography.h5.fontSize,
      }),
      headingOption6: ({ theme }) => ({
        fontSize: theme.typography.h6.fontSize,
      }),
    },
  },
};
